import { Field, Radio, RadioGroup } from '@fluentui/react-components';
import { Control, Controller, FieldErrors } from 'react-hook-form';

type TProps = {
  control: Control<any>;
  errors: FieldErrors<any>;
  name: string;
  label?: string;
  required?: boolean;
  disabled?: boolean;
  layout?: 'horizontal' | 'vertical';
  options: { value: string; label: string }[];
};

// A controlled radio group. ControlledField has no radio variant, so this wraps
// react-hook-form's Controller around Fluent's RadioGroup with matching error
// rendering (a red message under the field).
export const RadioField = ({
  control,
  errors,
  name,
  label,
  required = false,
  disabled = false,
  layout = 'horizontal',
  options,
}: TProps) => (
  <Field label={label} required={required}>
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <RadioGroup
          layout={layout}
          value={field.value ?? ''}
          onChange={(_, data) => field.onChange(data.value)}
          disabled={disabled}
        >
          {options.map((option) => (
            <Radio key={option.value} value={option.value} label={option.label} />
          ))}
        </RadioGroup>
      )}
    />
    {errors[name] ? (
      // @ts-expect-error message typing mirrors the shared ControlledField pattern
      <p className="text-red-500">{errors[name].message}</p>
    ) : null}
  </Field>
);
